import React from "react";
import "./VisionHelp.css";
import img1 from "../visionassets/help1.png";
import img2 from "../visionassets/help2.png";
import img3 from "../visionassets/help3.jpg";
import img4 from "../visionassets/help4.jpg";
import img5 from "../visionassets/help5.jpg";
import img6 from "../visionassets/help6.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NextArrow = ({ onClick }) => (
  <button className="custom-arrow next" onClick={onClick}>
    <FaChevronRight />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button className="custom-arrow prev" onClick={onClick}>
    <FaChevronLeft />
  </button>
);

export default function VisionHelp() {
  const gameCards = [
    {
      section: "top",
      img: img1,
      title: "Strategic Consulting & Advisory",
      desc: "Assess feasibility, define use cases, and build a clear roadmap through AI design sprints focused on image and video analysis.",
    },
    {
      section: "top",
      img: img4,
      title: "Proof of Concept (PoC) Development",
      desc: "Validate ideas quickly with functional prototypes that demonstrate real-world value and technical viability.",
    },
    {
      section: "top",
      img: img6,
      title: "Data Analysis, Quality Audit & Preparation",
      desc: "Perform data audits, labeling, augmentation, and exploratory analysis to ensure high-quality visual datasets.",
    },
    {
      section: "bottom",
      img: img5,
      title: "Computer Vision Software Development",
      desc: "Develop and deploy custom models for image classification, object detection, motion recognition, and video analytics at scale.",
    },
    {
      section: "bottom",
      img: img2,
      title: "Custom Product & AI Software Development",
      desc: "Build or enhance end-to-end computer vision products using agile methodologies and tailored architectures.",
    },
    {
      section: "bottom",
      img: img3,
      title: "Integration, Maintenance & Support",
      desc: "Seamlessly integrate computer vision systems into existing workflows and provide ongoing maintenance and production support.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    adaptiveHeight: true,
    centerMode: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div id="vision-help" className="outsourcemainclass">
      {/* <span className="span-tag">Our Game Development Expertise</span> */}
      <h2 className="heading">Trusted Game Development Company Worldwide</h2>
      <p className="subheading">
        We offer services with legacy — we build game development solutions that
        align with your vision and delight players.
      </p>

      <div className="cards">
        <div className="top-cards">
          {gameCards
            .filter((card) => card.section === "top")
            .map((card, index) => (
              <div className="card" key={index}>
                <div className="image-container">
                  <img src={card.img} alt={card.title} />
                  <div className="overlay"></div>
                </div>
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
        </div>
        <div className="bottom-cards">
          {gameCards
            .filter((card) => card.section === "bottom")
            .map((card, index) => (
              <div className="card" key={index}>
                <div className="image-container">
                  <img src={card.img} alt={card.title} />
                  <div className="overlay"></div>
                </div>
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="mobile-cards">
        <Slider {...settings}>
          {gameCards.map((card, index) => (
            <div className="card-wrapper" key={index}>
              <div className="card">
                <div className="image-container">
                  <img src={card.img} alt={card.title} />
                  <div className="overlay"></div>
                </div>
                <div className="content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
